import React, { useState, useEffect } from 'react';
import { auth, ml } from '../utils/api';
import toast from 'react-hot-toast';

const f = { fontFamily:"'Plus Jakarta Sans',sans-serif" };

const COUNTRIES = [
  { code:'CO', name:'Colombia', flag:'🇨🇴', mlUrl:'https://auth.mercadolibre.com.co/authorization', active:true },
  { code:'AR', name:'Argentina', flag:'🇦🇷', active:false },
  { code:'MX', name:'México', flag:'🇲🇽', active:false },
  { code:'CL', name:'Chile', flag:'🇨🇱', active:false },
  { code:'PE', name:'Perú', flag:'🇵🇪', active:false },
  { code:'EC', name:'Ecuador', flag:'🇪🇨', active:false },
];

const CLIENT_ID = '8376713972695185';
const REDIRECT_URI = 'https://ml.novaecom.io/api/auth/callback';

export default function ConfiguracionPage() {
  const [mlStatus, setMlStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState(false);

  useEffect(() => { loadStatus(); }, []);

  const loadStatus = async () => {
    try { const res = await ml.status(); setMlStatus(res.data); }
    catch (err) { setMlStatus({ connected: false }); }
    finally { setLoading(false); }
  };

  const handleConnect = () => {
    setConnecting(true);
    const url = `https://auth.mercadolibre.com.co/authorization?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&state=1`;
    window.location.href = url;
  };

  return (
    <div style={{ ...f, padding:'24px 28px', background:'#f5f5ef', minHeight:'100vh' }}>

      <div style={{ marginBottom:28 }}>
        <h1 style={{ fontSize:24, fontWeight:800, color:'#1a1a1a', letterSpacing:'-0.5px', margin:0 }}>Configuración</h1>
        <p style={{ fontSize:13, color:'#aaa', marginTop:4 }}>Conexión con Mercado Libre y estado del sistema</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>

        {/* ML Connect */}
        <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:20, padding:28 }}>
          <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
            <div style={{ width:44, height:44, borderRadius:12, background:'#ede9fe', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c5ef8" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><path d="M8 12l2 2 4-4"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize:15, fontWeight:800, color:'#1a1a1a' }}>Mercado Libre OAuth</div>
              <div style={{ fontSize:12, color:'#aaa', marginTop:2 }}>
                {loading ? 'Verificando...' : mlStatus?.connected ? '✅ Cuenta conectada' : '⚠️ Sin conectar'}
              </div>
            </div>
          </div>
          <p style={{ fontSize:13, color:'#888', lineHeight:1.6, marginBottom:20 }}>
            Conecta tu cuenta colombiana de Mercado Libre para sincronizar ventas, órdenes e inventario en tiempo real.
          </p>
          <button onClick={handleConnect} disabled={connecting}
            style={{ width:'100%', padding:14, borderRadius:12,
              background: connecting ? '#c4b5fd' : 'linear-gradient(135deg,#7c5ef8,#a855f7)',
              border:'none', color:'#fff', fontSize:14, fontWeight:700, cursor: connecting ? 'not-allowed' : 'pointer',
              fontFamily:'Plus Jakarta Sans,sans-serif', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/><path d="M8 12l2 2 4-4"/>
            </svg>
            {connecting ? 'Conectando...' : 'Conectar con Mercado Libre 🇨🇴'}
          </button>
        </div>

        {/* Estado sistema */}
        <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:20, padding:28 }}>
          <div style={{ fontSize:15, fontWeight:800, color:'#1a1a1a', marginBottom:20 }}>Estado del sistema</div>
          {[
            ['SSL/HTTPS',        'Activo',         '#3d7a00', '#e8f9d4'],
            ['Autenticación',    'JWT 7 días',      '#7c5ef8', '#ede9fe'],
            ['Sync automático',  'Cada 2 horas',    '#f97316', '#fff7ed'],
            ['Base de datos',    'MySQL activo',    '#3d7a00', '#e8f9d4'],
            ['País soportado',   'Colombia 🇨🇴',    '#1a1a1a', '#f5f5ef'],
          ].map(([k,v,color,bg]) => (
            <div key={k} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'11px 0', borderBottom:'1px solid #f8f8f4', fontSize:13 }}>
              <span style={{ color:'#888', fontWeight:500 }}>{k}</span>
              <span style={{ padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700, background:bg, color }}>{v}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Países próximamente */}
      <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:20, padding:28 }}>
        <div style={{ fontSize:15, fontWeight:800, color:'#1a1a1a', marginBottom:6 }}>Próximos países</div>
        <div style={{ fontSize:13, color:'#aaa', marginBottom:20 }}>Expansión a más países de Latinoamérica próximamente</div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(6,1fr)', gap:10 }}>
          {COUNTRIES.map(c => (
            <div key={c.code} style={{ background: c.active ? '#ede9fe' : '#fafaf5', border:`1.5px solid ${c.active ? '#7c5ef8' : '#e8e8e0'}`, borderRadius:12, padding:'12px 8px', textAlign:'center' }}>
              <div style={{ fontSize:22, marginBottom:4 }}>{c.flag}</div>
              <div style={{ fontSize:12, fontWeight:700, color: c.active ? '#7c5ef8' : '#bbb' }}>{c.name}</div>
              {c.active
                ? <div style={{ fontSize:10, color:'#7c5ef8', fontWeight:700, marginTop:4 }}>ACTIVO</div>
                : <div style={{ fontSize:10, color:'#ccc', fontWeight:700, marginTop:4 }}>PRONTO</div>
              }
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
